module.exports = __webpack_public_path__ + "static/media/dcbXbnk.0c027bfc.png";